import { useIntl } from 'react-intl';
import styled from 'styled-components';

import type { ServicesConsents } from '@xing-com/cookie-consent-usercentrics';
import { VIMEO, YOUTUBE } from '@xing-com/crate-jobs-constants';
import { EmptyState as EmptyStateComponent } from '@xing-com/empty-state';
import { IllustrationEmptyStateView } from '@xing-com/illustrations';
import { spaceXXL } from '@xing-com/tokens';

export type Provider = 'Youtube' | 'Vimeo';

type Props = {
  provider: Provider;
};

const getId = (provider: Provider): string | undefined => {
  if (provider === 'Youtube') return YOUTUBE;
  if (provider === 'Vimeo') return VIMEO;
  return undefined;
};

const giveConsent = async (provider: Provider): Promise<void> => {
  const id = getId(provider);
  if (id) {
    const serviceConsents: ServicesConsents = [{ id, consent: true }];
    await window.__ucCmp?.updateServicesConsents(serviceConsents);
    await window.__ucCmp?.saveConsents();
  }
};

export const VideoConsentPlaceholder: React.FC<Props> = ({ provider }) => {
  const { formatMessage } = useIntl();

  const headlineText = formatMessage(
    { id: 'JOBS_JOB_DETAILS_CONSENT_BANNER_HEADLINE_WEB' },
    { provider }
  );
  const bodyCopyText = formatMessage({
    id: 'JOBS_JOB_DETAILS_CONSENT_BANNER_DESCRIPTION',
  });
  const buttonText = formatMessage({
    id: 'JOBS_JOB_DETAILS_CONSENT_BANNER_BUTTON',
  });

  return (
    <EmptyState
      bodyCopyText={bodyCopyText}
      buttonText={buttonText}
      buttonProps={{
        onClick: () => giveConsent(provider),
      }}
      headlineText={headlineText}
      illustration={IllustrationEmptyStateView}
      size="medium"
      variant="default"
      withBackground
    />
  );
};

const EmptyState = styled(EmptyStateComponent)`
  margin: ${spaceXXL} 0;
`;
